/* ==========================================================================
   LT INTERNATIONAL — 6-STAGE CLINICAL ADVISOR INTERFACE CONTROLLER (V9)
   ========================================================================== */

document.addEventListener("DOMContentLoaded", () => {
  initAdvisorFlow();
});

function initAdvisorFlow() {
  const steps = document.querySelectorAll(".step-pane");
  const progressNodes = document.querySelectorAll(".progress-node");
  const progressBarFill = document.querySelector(".progress-bar-fill");
  const prevBtn = document.getElementById("advisor-prev-btn");
  const nextBtn = document.getElementById("advisor-next-btn");
  
  if (steps.length === 0) return;

  let currentStep = 0;
  const totalSteps = steps.length;
  
  // Selection states mapping
  const selections = {
    goal: "",
    glyco: "",
    sugar: "",
    age: "",
    resveratrol: "",
    email: ""
  };

  // Option cards interactive select handler
  const optionCards = document.querySelectorAll(".selection-option-card");
  optionCards.forEach(card => {
    card.addEventListener("click", () => {
      const type = card.dataset.type;
      const val = card.dataset.value;
      
      const siblingCards = document.querySelectorAll(`.selection-option-card[data-type="${type}"]`);
      siblingCards.forEach(c => c.classList.remove("selected"));
      
      card.classList.add("selected");
      selections[type] = val;
      
      validateCurrentStep();
    });
  });

  const emailInput = document.getElementById("advisor-email-field");
  if (emailInput) {
    emailInput.addEventListener("input", () => {
      selections.email = emailInput.value.trim();
      validateCurrentStep();
    });
  }

  function validateCurrentStep() {
    let isValid = false;
    if (currentStep === 0 && selections.goal !== "") isValid = true;
    else if (currentStep === 1 && selections.glyco !== "") isValid = true;
    else if (currentStep === 2 && selections.sugar !== "") isValid = true;
    else if (currentStep === 3 && selections.age !== "") isValid = true;
    else if (currentStep === 4 && selections.resveratrol !== "") isValid = true;
    else if (currentStep === 5 && validateEmail(selections.email)) isValid = true;
    
    nextBtn.disabled = !isValid;
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  nextBtn.addEventListener("click", () => {
    if (currentStep < totalSteps - 1) {
      currentStep++;
      updateStepUI();
    } else {
      triggerBiometricScan();
    }
  });

  prevBtn.addEventListener("click", () => {
    if (currentStep > 0) {
      currentStep--;
      updateStepUI();
    }
  });

  function updateStepUI() {
    steps.forEach(pane => pane.classList.remove("active"));
    steps[currentStep].classList.add("active");

    progressNodes.forEach((node, idx) => {
      node.classList.remove("active", "completed");
      if (idx === currentStep) {
        node.classList.add("active");
      } else if (idx < currentStep) {
        node.classList.add("completed");
      }
    });

    const progressPercent = (currentStep / (totalSteps - 1)) * 100;
    progressBarFill.style.width = `${progressPercent}%`;

    prevBtn.disabled = currentStep === 0;
    validateCurrentStep();
    
    if (currentStep === totalSteps - 1) {
      nextBtn.textContent = "Initiate Telemetry Scan";
    } else {
      nextBtn.textContent = "Next Step";
    }
  }

  /**
   * simulated Biometric Analyzer and laser scan transition logger
   */
  function triggerBiometricScan() {
    const formCard = document.querySelector(".portal-card");
    const scanPane = document.querySelector(".scanning-pane");
    const progressHeader = document.querySelector(".progress-header");
    const consoleLogs = document.getElementById("scanning-console");

    formCard.style.opacity = "0.15";
    formCard.style.transform = "translateY(-10px)";
    
    setTimeout(() => {
      formCard.style.display = "none";
      progressHeader.style.display = "none";
      scanPane.classList.add("active");
      
      // Dynamic scanning terminal logs
      const logLines = [
        "Establishing secured clinical biometric link...",
        "Scanning intracellular glucose saturation ratios...",
        "Assaying collagen Advanced Glycation End-products (AGEs)...",
        "Quantifying Hayflick telomere copying replication tiers...",
        "Cross-referencing polyphenol resveratrol grape co-factors...",
        "Calibrating fractured-wall chlorella density curves...",
        "Generating metabolic PPAR recovery matrix...",
        "CALIBRATION TELEMETRY SECURED SUCCESSFULLY!"
      ];

      if (consoleLogs) {
        consoleLogs.innerHTML = "";
        logLines.forEach((line, index) => {
          setTimeout(() => {
            const p = document.createElement("div");
            p.textContent = `> ${line}`;
            p.style.color = index === logLines.length - 1 ? "var(--accent-gold)" : "var(--color-text-muted)";
            consoleLogs.appendChild(p);
            consoleLogs.scrollTop = consoleLogs.scrollHeight;
          }, index * 400);
        });
      }

      setTimeout(() => {
        scanPane.classList.remove("active");
        renderResults();
      }, logLines.length * 400 + 400);
    }, 450);
  }

  /**
   * Formulate deep result matrix based on clinical markers
   */
  function renderResults() {
    const resultsPane = document.querySelector(".results-pane");
    const rTitle = document.getElementById("res-title");
    const rBadge = document.getElementById("res-badge");
    const rDesc = document.getElementById("res-desc");
    const rGraphic = document.getElementById("res-graphic");
    
    const rDosageVal = document.getElementById("res-dosage-val");
    const rGaugeFill = document.getElementById("res-gauge-fill");
    const rSchedule = document.getElementById("res-dosage-schedule");
    
    const rProductName = document.getElementById("res-prod-name");
    const rProductSub = document.getElementById("res-prod-sub");
    const checkoutBtn = document.getElementById("advisor-checkout-btn");

    let protocolKey = "base";

    // Decision Logic
    if (selections.goal === "metabolic" || selections.sugar === "high" || selections.glyco === "fatigue") {
      protocolKey = "glucose";
    } else if (selections.goal === "longevity" || selections.age === "tier3" || selections.resveratrol === "low") {
      protocolKey = "longevity";
    }

    if (protocolKey === "glucose") {
      rTitle.textContent = "PPAR Glucose Modulator Protocol 🩸";
      rBadge.textContent = "Phase III Metabolic Restore";
      rDesc.textContent = "Intake Sweep Successful. Your biological markers display elevated glycation tension post-meals. We prescribe our Mother's & Father's Special Package comprising 2 bottles of CRIII Original (600 Tabs) plus 1 bottle of 300 Tabs PWP for just RM1. Take exactly 8 tablets daily in the morning to optimize insulin receptor sensitivity.";
      rGraphic.src = "./diabetes_cutout.png";
      rGraphic.alt = "Glucose Modulator";
      
      rDosageVal.textContent = "8 Tablets / Day";
      rGaugeFill.style.width = "85%";
      rSchedule.textContent = "Active Booster Routine: Take 8 fractured-cell tablets with 250ml warm water in the morning, best paired with grape polyphenol juice to maximize PPAR receptor modulation.";
      
      rProductName.textContent = "Mother's & Father's Special (PWP)";
      rProductSub.textContent = "RM997.00 - 2x 600 Tabs + 1x 300 Tabs for RM1";
    } else if (protocolKey === "longevity") {
      rTitle.textContent = "SIRT-1 Active Telomere Extension ♾️";
      rBadge.textContent = "Phase V Longevity Protocol";
      rDesc.textContent = "Intake Sweep Successful. Your profile exhibits deep telomere division bounds strain. We prescribe the CRIII Original 600 Tabs Flagship bottle to trigger SIRT-1 pathways and preserve baseline chronological boundaries.";
      rGraphic.src = "./longevity_elderly_walk.png";
      rGraphic.alt = "Telomere Longevity";
      
      rDosageVal.textContent = "6 Tablets / Day";
      rGaugeFill.style.width = "95%";
      rSchedule.textContent = "Longevity Shield Routine: Take 6 cracked-cell tablets daily before bedtime with warm water to optimize chromosome cap defense during deep autophagic sweep phases.";
      
      rProductName.textContent = "CRIII Original Flagship (600 Tabs)";
      rProductSub.textContent = "RM498.00 - High Purity Cellular Longevity Shield";
    } else {
      rTitle.textContent = "Targeted Cellular Recovery Sweep 🧬";
      rBadge.textContent = "Phase I Base Recovery Protocol";
      rDesc.textContent = "Intake Sweep Successful. Your biological markers are balanced. We prescribe the CRIII Original Base 300 Tabs bottle for daily cellular sweep maintenance, ensuring DNA strand transcription remain error-free.";
      rGraphic.src = "./cancer_cell_cutout.png";
      rGraphic.alt = "Intracellular Sweep";
      
      rDosageVal.textContent = "3 Tablets / Day";
      rGaugeFill.style.width = "65%";
      rSchedule.textContent = "Daily Maintenance Routine: Take 3 chewable tablets with warm water in the morning to preserve daily baseline cellular boundaries and oxidative shield bounds.";
      
      rProductName.textContent = "CRIII Original Base (300 Tabs)";
      rProductSub.textContent = "RM265.00 - Baseline Cellular Protection";
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", () => {
        alert(`Proceeding securely to LT checkout with your customized ${rProductName.textContent}!`);
        window.location.href = `./product.html`;
      });
    }

    resultsPane.classList.add("active");
  }

  updateStepUI();
}
